import { type Writable, writable } from 'svelte/store';

import { type IProfile } from '@shared/models';

import { STORAGE_KEYS } from '../constants';
import { storageService } from '../services/storageService';

export const profiles: Writable<Record<string, IProfile>> = writable({});

export async function initProfiles(): Promise<void> {
  try {
    const raw = await storageService.getItem(STORAGE_KEYS.ProfilesData);
    const parsed = JSON.parse(raw || '{}');
    profiles.set(parsed);
  } catch {
    // Corrupt storage data — fall back to empty
  }
}
